export enum TercType {
  GMINA_MIEJSKA = 1,
  GMINA_WIEJSKA = 2,
  GMINA_MIEJSKO_WIEJSKA = 3,
  MIASTO = 4,
  OBSZAR_WIEJSKI = 5,
  DZIELNICA = 8,
  DELEGATURA = 9,
  WOJEWODZTWO = 100,
  POWIAT = 110,
  GMINA = 120
}
